import { render, staticRenderFns } from "./AdminsForm.vue?vue&type=template&id=701bb879&"
import script from "./AdminsForm.vue?vue&type=script&lang=js&"
export * from "./AdminsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports